module.exports = __webpack_public_path__ + "media/dingdown.b506a66a.mp3";